import { render, staticRenderFns } from "./ResidenceInformationReview.vue?vue&type=template&id=34670379&"
import script from "./ResidenceInformationReview.vue?vue&type=script&lang=js&"
export * from "./ResidenceInformationReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports